import { goalActivity as goalActivityConfig } from 'shared/api/query/configs.json';
import { propertyType } from 'shared/constants.json';

export const directProperties = ($t) => ([
  // TODO: this originally was created to fit a flow in Custom Charts, but I'm not sure if it is working as it should be
  // {
  //   label: $t('general.createdAt'),
  //   edgeName: CREATED_AT,
  //   type: propertyType.date,
  //   isTitle: false,
  //   hideInProps: true,
  //   noFilter: false,
  //   noIsEmptyFilter: true,
  //   showByDefault: true,
  // },
  {
    label: $t('general.createdAt'),
    edgeName: goalActivityConfig.edges.customCreatedAt,
    type: propertyType.date,
    isTitle: false,
    hideInProps: true,
    noFilter: false,
    noIsEmptyFilter: true,
    showByDefault: true,
  },
]);
